import React, { useState } from 'react';
import './Gallery.css';
import { useLanguage } from '../context/LanguageContext';

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const galleryItems = [
    { id: 1, category: 'temple', titleKey: 'gallery.galleryItems.mainTemple', descKey: 'gallery.galleryItems.mainTempleDesc', image: '/Assets/home/dev.jpg' },
    { id: 2, category: 'temple', titleKey: 'gallery.galleryItems.templeEntrance', descKey: 'gallery.galleryItems.templeEntranceDesc', image: '/Assets/home/mukhya dwar.jpg' },
    { id: 3, category: 'temple', titleKey: 'gallery.galleryItems.innerSanctum', descKey: 'gallery.galleryItems.innerSanctumDesc', image: '/Assets/home/main mandir.jpg' },
    { id: 13, category: 'temple', titleKey: 'gallery.galleryItems.drushya1', descKey: 'gallery.galleryItems.drushya1Desc', image: '/Assets/gallery/drushya_1.jpg' },
    { id: 14, category: 'temple', titleKey: 'gallery.galleryItems.drushya2', descKey: 'gallery.galleryItems.drushya2Desc', image: '/Assets/gallery/drushya_2.jpg' },
    { id: 15, category: 'temple', titleKey: 'gallery.galleryItems.drushya3', descKey: 'gallery.galleryItems.drushya3Desc', image: '/Assets/gallery/drushya_3.jpg' },
    { id: 16, category: 'temple', titleKey: 'gallery.galleryItems.drushya4', descKey: 'gallery.galleryItems.drushya4Desc', image: '/Assets/gallery/drushya_4.jpg' },
    { id: 17, category: 'temple', titleKey: 'gallery.galleryItems.drushya5', descKey: 'gallery.galleryItems.drushya5Desc', image: '/Assets/gallery/drushya_5.jpg' },
    { id: 4, category: 'festival', titleKey: 'gallery.galleryItems.san1', descKey: 'gallery.galleryItems.san1Desc', image: '/Assets/gallery/san_1.jpg' },
    { id: 5, category: 'festival', titleKey: 'gallery.galleryItems.san2', descKey: 'gallery.galleryItems.san2Desc', image: '/Assets/gallery/san_2.jpg' },
    { id: 6, category: 'festival', titleKey: 'gallery.galleryItems.san3', descKey: 'gallery.galleryItems.san3Desc', image: '/Assets/gallery/san_3.jpg' },
    { id: 9, category: 'facilities', titleKey: 'gallery.galleryItems.bhaktaNiwas', descKey: 'gallery.galleryItems.bhaktaNiwasDesc', image: '/Assets/gallery/bhakta niwas.jpg' },
    { id: 10, category: 'facilities', titleKey: 'gallery.galleryItems.annaKshetra', descKey: 'gallery.galleryItems.annaKshetraDesc', image: '/Assets/gallery/annas seva.jpg' },
    { id: 11, category: 'facilities', titleKey: 'gallery.galleryItems.templeGarden', descKey: 'gallery.galleryItems.templeGardenDesc', image: '/Assets/gallery/garden.jpg' },
    { id: 12, category: 'facilities', titleKey: 'gallery.galleryItems.gauShala', descKey: 'gallery.galleryItems.gauShalaDesc', image: '/Assets/gallery/gau shala.jpg' }
  ];

  const categories = [
    { id: 'all', labelKey: 'gallery.all' },
    { id: 'temple', labelKey: 'gallery.temple' },
    { id: 'festival', labelKey: 'gallery.festivals' },
    { id: 'facilities', labelKey: 'gallery.facilities' }
  ];

  const filteredItems = activeCategory === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeCategory);

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-pill">{t('gallery.pageTitle')}</span>
          <h1>{t('gallery.pageSubtitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="gallery-filters">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`filter-btn ${activeCategory === cat.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              <span>{t(cat.labelKey)}</span>
            </button>
          ))}
        </div>

        <div className="gallery-grid">
          {filteredItems.map(item => (
            <div 
              key={item.id} 
              className="gallery-item"
              onClick={() => setSelectedImage(item)}
            >
              <img 
                src={item.image} 
                alt={t(item.titleKey)} 
                className="gallery-image" 
                loading="lazy" 
              />
              <div className="gallery-overlay">
                <h3>{t(item.titleKey)}</h3>
                <p>{t(item.descKey)}</p>
              </div>
            </div>
          ))}
        </div>

      </div>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
            <img 
              src={selectedImage.image} 
              alt={t(selectedImage.titleKey)} 
              className="lightbox-image" 
            />
            <h3 className="lightbox-title">{t(selectedImage.titleKey)}</h3>
            <p className="lightbox-description">{t(selectedImage.descKey)}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
